import React, { useEffect, useCallback, useRef, useState } from 'react';

let breaks = [];
let timerId = 0;
const counter = 0;

function GradingGroupTabs({ gradingGroups, selectedGradGroup, onChangeGradGroup, isProductArchived }) {
  const [greedyMenuList, setGreedyMenuList] = useState([]);
  const [activeUnderline, setActiveUnderline] = useState({});

  const navRef = useRef(null);
  const btnRef = useRef(null);
  const vlinksRef = useRef(null);
  const hlinksRef = useRef(null);

  const updateNav = useCallback(() => {
    timerId = setTimeout(() => {
      try {
        const nav = navRef.current;
        const btn = btnRef.current;
        const vlinks = vlinksRef.current;
        const hlinks = hlinksRef.current;

        if (nav && btn && vlinks && hlinks) {
          const availableSpace = btn.classList.contains('hidden') ? nav.clientWidth : nav.clientWidth - btn.clientWidth;
          if (vlinks.clientWidth > availableSpace) {
            if (vlinks.lastChild) {
              breaks.push(vlinks.clientWidth);
              hlinks.prepend(vlinks.lastChild);
            }
            if (btn.classList.contains('hidden')) {
              btn.classList.remove('hidden');
            }
          } else {
            if (availableSpace > breaks[breaks.length - 1] && hlinks.lastChild) {
              vlinks.append(hlinks.firstChild);
              breaks.pop();
            }
            if (breaks.length < 1) {
              btn.classList.add('hidden');
              hlinks.classList.add('hidden');
            }
          }
          btn.setAttribute('count', breaks.length);
          if (vlinks.clientWidth > availableSpace) {
            updateNav();
          }
        } else {
          // refs not yet attached (greedyMenuList empty or component not rendered) — skip silently
        }
      } catch (error) {
        console.log('updateNav error', error);
      }
    }, 100);
  }, []);

  const toggleHidden = () => {
    try {
      const hlinks = hlinksRef.current;
      if (hlinks) {
        hlinks.classList.toggle('hidden');
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    if (timerId) clearTimeout(timerId);
    setGreedyMenuList(gradingGroups || []);
    updateNav();
    window.addEventListener('resize', updateNav);
    return () => {
      if (timerId) clearTimeout(timerId);
      window.removeEventListener('resize', updateNav);
    };
  }, [gradingGroups, updateNav]);

  useEffect(() => {
    if (vlinksRef.current && selectedGradGroup?.value && greedyMenuList?.length > 0) {
      const activeTab = vlinksRef.current.querySelector('.active');
      if (activeTab) {
        const tabRect = activeTab.getBoundingClientRect();
        const parentRect = vlinksRef.current.getBoundingClientRect();
        setActiveUnderline({
          width: tabRect.width,
          left: tabRect.left - parentRect.left,
        });
      } else {
        setActiveUnderline({ width: 0, display: 'none' });
      }
    }
  }, [selectedGradGroup, greedyMenuList]);

  useEffect(() => {
    return () => {
      breaks = [];
    };
  }, []);

  if (!greedyMenuList || greedyMenuList.length === 0) return null;

  return (
    <nav className="greedy-nav" ref={navRef}>
      <ul className="subnav-ul visible-links" ref={vlinksRef}>
        {greedyMenuList.map((group) => (
          <React.Fragment key={group.value}>
            <li className={selectedGradGroup?.value === group.value ? 'active' : ''}>
              <button type="button">
                <div className="tab-item">
                  <span
                    className="d-flex text-bold ml-0 align-items-center"
                    onClick={() => {
                      if (!isProductArchived) onChangeGradGroup(group);
                    }}
                  >
                    {group.label}
                  </span>
                </div>
              </button>
            </li>
          </React.Fragment>
        ))}
      </ul>
      <button type="button" className="btn-more-dropdown hidden" onClick={toggleHidden} ref={btnRef}>
        <span className="icon-More f-32 text-black" />
      </button>
      <ul className="hidden-links hidden" ref={hlinksRef} />
      <div className="tab-underline" style={activeUnderline} />
    </nav>
  );
}

export default GradingGroupTabs;
